import { z } from 'zod';
import { aliasRegex } from '../common/alias.js';
import { userDtoSchema } from '../users/user.schemas.js';

export const loginSchema = z.object({
  alias: z
    .string()
    .trim()
    .min(1, { message: 'L’alias est obligatoire' })
    .max(64, { message: 'Alias trop long' })
    .regex(aliasRegex, { message: 'Caractères autorisés : a-z 0-9 . _ -' }),
  password: z
    .string()
    .min(1, { message: 'Le mot de passe est obligatoire' })
    .max(200, { message: 'Mot de passe trop long' }),
});

export const registerSchema = z.object({
  alias: z
    .string()
    .min(3)
    .max(64)
    .regex(aliasRegex, { message: 'Caractères autorisés : a-z 0-9 . _ -' }),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  email: z
    .string()
    .email({ message: 'Adresse e-mail invalide' })
    .max(255, { message: 'E-mail trop long' })
    .optional()
    .or(z.literal(''))
    .transform((v) => (v === '' ? undefined : v)),
  phone: z.string().max(50).optional(),
  password: z
    .string()
    .min(12, { message: 'Le mot de passe doit contenir au moins 12 caractères' })
    .max(200, { message: 'Mot de passe trop long' }),
});

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, { message: 'Le mot de passe actuel est obligatoire' })
      .max(200, { message: 'Mot de passe trop long' }),
    newPassword: z
      .string()
      .min(12, { message: 'Le nouveau mot de passe doit contenir au moins 12 caractères' })
      .max(200, { message: 'Mot de passe trop long' }),
  })
  .refine((data) => data.currentPassword !== data.newPassword, {
    message: 'Le nouveau mot de passe doit être différent de l’actuel',
    path: ['newPassword'],
  });

export const authResponseSchema = z.object({
  accessToken: z.string(),
  user: userDtoSchema,
});

/** Indique si le navigateur envoie déjà un cookie refresh (évite un POST /refresh inutile au boot). */
export const authSessionHintSchema = z.object({
  refreshCookiePresent: z.boolean(),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
export type AuthResponse = z.infer<typeof authResponseSchema>;
export type AuthSessionHint = z.infer<typeof authSessionHintSchema>;
